import { render, staticRenderFns } from "./Scheadule.vue?vue&type=template&id=72196344&"
import script from "./Scheadule.vue?vue&type=script&lang=js&"
export * from "./Scheadule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports